import React from "react";
// import Checkbox from "../Checkbox";
// import toDisplayCase from "../toDisplayCase";
import { Checkbox, toDisplayCase } from "../../nq-component";

function Head({
  selectable,
  fields,
  excludeFields,
  actionsList,
  selected,
  onSelectAll,
  objects,
  onSort,
}) {
  let isFirstVisible = true;
  const [sortState, setSortState] = React.useState({
    field: null,
    direction: "asc",
  });

  function handleSortClick(type, field) {
    let newDirection = "asc";
    if (sortState.field === field) {
      newDirection = sortState.direction === "asc" ? "desc" : "asc";
    }
    setSortState({ field, direction: newDirection });
    onSort(type, field, newDirection);
  }
  return (
    <tr style={{ backgroundColor: "#e09552" }}>
      {selectable && (
        <th
          style={{
            backgroundColor: "#e09552",
            color: "white",
            borderRadius: "10px 0 0 0",
          }}
        >
          <Checkbox
            className="align-middle"
            id="check_all"
            checked={objects.length === selected.length && objects.length !== 0}
            onChange={(checked) => onSelectAll(checked)}
          />
        </th>
      )}
      <th
        style={{
          backgroundColor: "#e09552",
          color: "white",
          borderRadius: "10px 0 0 0",
        }}
        className="fs-xs align-middle text-nowrap"
      >
        Last Name
      </th>
      {Object.keys(fields).map((field, index) => {
        const { type, ...options } = fields[field];
        if (excludeFields.includes(field)) return null;
        const label = options.label || toDisplayCase(field);
        const isFirst = isFirstVisible;
        isFirstVisible = false;

        const isSorted = sortState.field === field;
        const iconClass = isSorted
          ? sortState.direction === "asc"
            ? "bi bi-sort-down-alt"
            : "bi bi-sort-up"
          : "";

        return (
          <th
            key={field}
            onClick={() => handleSortClick(type, field)}
            className="fs-xs align-middle text-nowrap"
            style={{
              backgroundColor: "#e09552",
              color: "white",
              cursor: "pointer",
              // borderRadius: isFirst ? "10px 0 0 0" : "",
            }}
          >
            <span>
              {label} <i className={iconClass}></i>
            </span>
          </th>
        );
      })}

      <th
        style={{
          backgroundColor: "#e09552",
          color: "white",
          borderRadius: "0",
        }}
        className="fs-xs align-middle text-nowrap"
      >
        Status
      </th>
      {actionsList.length > 0 && (
        <>
          <th
            style={{
              backgroundColor: "#e09552",
              borderRadius: "10px",
            }}
          >
            <div style={{ width: "50px" }}></div>
          </th>
          <th
            className="fs-xs align-middle text-nowrap"
            colSpan={actionsList.length}
            style={{ borderRadius: "10px" }}
          >
            ACTIONS
          </th>
        </>
      )}

      <>
        {/* <th>
          <div style={{ width: "50px" }}></div>
        </th> */}
        <th
          className="fs-xs align-middle text-nowrap"
          style={{
            backgroundColor: "#e09552",
            color: "white",
            borderRadius: "0px 10px 0px 0px",
          }}
          colSpan={actionsList.length}
        >
          {objects[0]?.roles?.[0]?.name ? "Role" : null}
        </th>
      </>
    </tr>
  );
}

export default Head;
